function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Logo/Logo-Contents/Icon"
}, React.createElement("path", {
  id: "Bottom Lines - Secondary100",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 9.19174C10.1264 9.19174 8.30434 8.96095 6.5589 8.52492C7.23389 9.22735 7.87275 9.96775 8.47225 10.7426C9.62479 10.9123 10.8025 11 12 11C13.1975 11 14.3752 10.9123 15.5277 10.7426C16.127 9.96775 16.766 9.22735 17.441 8.52492C15.6957 8.96095 13.8737 9.19174 12 9.19174ZM6.81854 3.11912L3 5.4176C3.5309 5.80427 4.04752 6.21064 4.54899 6.63579L12 2.1506L19.451 6.63579C19.9525 6.21064 20.4691 5.80427 21 5.4176L12 0L6.81854 3.11912Z",
  fill: "#0094D9"
}), React.createElement("path", {
  id: "Top Lines - Primary100",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.2763 9.58751C17.0859 12.5775 14.7223 16.5063 13.5862 20.9567L13.5833 20.9674L13.5814 20.9749C13.3851 21.7466 13.2255 22.5342 13.105 23.3352L12 24L10.8949 23.3352C10.7744 22.5342 10.6149 21.7466 10.4185 20.9749L10.4138 20.9567C9.27765 16.5064 6.91407 12.5776 3.72372 9.58761C3.17305 9.07155 2.59788 8.58339 2 8.12551V6C2.59341 6.40879 3.16849 6.84401 3.72372 7.30426C7.07088 10.0792 9.69421 13.7615 11.2508 17.9942C11.5374 18.7735 11.7879 19.5714 12 20.3857C12.2121 19.5714 12.4626 18.7735 12.7491 17.9942C14.3058 13.7615 16.929 10.0792 20.2763 7.30426C20.8315 6.84401 21.4066 6.4087 22 6V8.12541C21.4022 8.58339 20.8269 9.07145 20.2763 9.58751ZM20.2763 16.9475L15.3589 19.9056C15.0962 20.7083 14.8771 21.5318 14.7041 22.3732L22 17.9845V9.97543C21.3967 10.4875 20.8213 11.0338 20.2763 11.6114V16.9475ZM2 9.97552C2.60329 10.4875 3.17875 11.0338 3.72372 11.6114V16.9475L8.64112 19.9056C8.90373 20.7082 9.12293 21.5318 9.29588 22.3732L2 17.9845V9.97552Z",
  fill: "#FFFFFF"
}));

var SvgItentialIconNegative = function SvgItentialIconNegative(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgItentialIconNegative, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/itential-icon-negative.6cc45db8.svg";
export { ForwardRef as ReactComponent };